import HTTP from '@/api/HTTP';
import generalTransformer from '@/services/general/transform';

const URL_BASE = 'gescom/RecommandationDevisAnonyme';

export async function getRecomAnonymeAsync() {
  const response = await HTTP.get(`${URL_BASE}/GetAnonymeRecommandationDevisAsync`);
  return response;
}

export async function getPanneauxSousContratAnonymeAsync() {
  const response = await HTTP.get(`${URL_BASE}/GetPanneauxSousContratAnonymeAsync`);
  return response;
}

export async function getConcurrentsAnonymeAsync(serverTableData) {
  const inputServer = generalTransformer(serverTableData);
  const url = `${URL_BASE}/PGetAnonymeConcurrentsRecommandationDevisAsync`;
  const response = await HTTP.post(url, inputServer);
  return response;
}

export async function getRecomClientAsync(hash) {
  const response = await HTTP.get(`${URL_BASE}/GetClientPortailAsync`, { params: { hash } });
  return response;
}

